<!-- https://8es9hr.axshare.com/#g=1&p=%E6%96%B0%E5%A2%9E%E5%8A%A0%E4%BF%9D%E7%94%B3%E8%AB%8B%E5%90%8D%E5%86%8A
     -->
<!-- 新增加保申請名冊 -->
<template>
  <div class="row">
    <div class="col-12">
      <div class="col-block">
        <div class="block-header has-border">
          <h3>
            <strong>加保作業</strong>
          </h3>
        </div>
        <div class="block-content">
          <el-tabs type="border-card">
            <el-tab-pane label="基本資料">
              <el-form label-position="top">
                <el-form-item label="申請方案">
                  <el-select
                    v-model="recordToEdit.insCadreYearId"
                    placeholder="請選擇"
                    :disabled="isSubmit"
                  >
                    <el-option
                      v-for="item in yearData"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <el-select
                    v-model="recordToEdit.insCadreSubId"
                    placeholder="請選擇"
                    class="ml10"
                    :disabled="isSubmit"
                  >
                    <el-option
                      v-for="item in selectProject"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <br />
                </el-form-item>
                <el-form-item label="選擇幹部名單" v-if="id == 'new'">
                  <el-select
                    v-model="recordToEdit.cadreTitle"
                    placeholder="選任理監事"
                  >
                    <el-option
                      v-for="(item, index) in titleList"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                  <el-select
                    v-model="SelectCadre"
                    class="ml10 mr10"
                    placeholder="職稱 姓名選單"
                  >
                    <el-option
                      v-for="(item, index) in cadreList"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="幹部類別" v-else>
                  <strong>{{ getCadre(recordToEdit.cadreType) }}</strong>
                </el-form-item>
                <el-form-item label="確認申請人資料" v-if="id !== 'new'">
                  <table class="table table-bordered info">
                    <tbody>
                      <tr>
                        <td>姓名</td>
                        <td>
                          <el-input
                            class="mt10 mb10"
                            v-model="recordToEdit.name"
                            :disabled="isSubmit"
                          ></el-input>
                        </td>
                      </tr>
                      <tr>
                        <td>性別</td>
                        <td>
                          <el-radio v-model="recordToEdit.sex" :label="2" :disabled="isSubmit"
                            >女性</el-radio
                          >
                          <el-radio v-model="recordToEdit.sex" :label="1" :disabled="isSubmit"
                            >男性</el-radio
                          >
                        </td>
                      </tr>
                      <tr>
                        <td>證件號碼 (身分證/居留證等)</td>
                        <td>
                          <el-input
                            class="mt10 mb10"
                            v-model="recordToEdit.idNumber"
                            :disabled="isSubmit"
                          ></el-input>
                          </td>
                      </tr>
                      <tr>
                        <td>出生年月</td>
                        <td>
                          <div class="date mt10">
                            <input
                              type="text"
                              class="min_go_date birthday1 birthday"
                              placeholder="選擇日期"
                              :disabled="id !== 'new' ? true : false"
                            />
                            <span class="el-input__prefix">
                              <i class="el-icon-date"></i>
                            </span>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>職稱</td>
                        <td>
                          <el-input
                            class="mt10 mb10"
                            v-model="recordToEdit.title"
                            :disabled="isSubmit"
                          ></el-input>
                        </td>
                      </tr>
                      <tr>
                        <td>任期</td>
                        <td>
                          <div class="date mt10">
                            <input
                              type="text"
                              class="min_go_date cadreStartDate1 cadreStartDate"
                              placeholder="選擇日期"
                              :disabled="id !== 'new' ? true : false"
                            />
                            <span class="el-input__prefix">
                              <i class="el-icon-date"></i>
                            </span>
                          </div>
                          ~
                          <div class="date">
                            <input
                              type="text"
                              class="min_go_date cadreEndDate1 cadreEndDate"
                              placeholder="選擇日期"
                              :disabled="id !== 'new' ? true : false"
                            />
                            <span class="el-input__prefix">
                              <i class="el-icon-date"></i>
                            </span>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>身份別</td>
                        <td>{{ recordToEdit.allCadreType }}</td>
                      </tr>
                    </tbody>
                  </table>
                </el-form-item>
                <el-form-item label="確認申請人資料" v-if="id == 'new'">
                  <span style="color: red" v-if="id == 'new'">{{
                    recordToEdit.applyTypeStr
                  }}</span>
                  <span
                    style="color: red"
                    v-if="id == 'new' && !recordToEdit.applyTypeStr"
                    >新加保</span
                  >
                  <table class="table table-bordered mb-0">
                    <tbody>
                      <tr>
                        <td>姓名</td>
                        <td>
                          <el-input
                            class="mt10 mb10"
                            v-model="recordToEdit.name"
                          ></el-input>
                        </td>
                      </tr>
                      <tr>
                        <td>性別</td>
                        <td>
                          <el-radio v-model="recordToEdit.sex" :label="2"
                            >女性</el-radio
                          >
                          <el-radio v-model="recordToEdit.sex" :label="1"
                            >男性</el-radio
                          >
                        </td>
                      </tr>
                      <tr>
                        <td>證件號碼 (身分證/居留證等)</td>
                        <td>
                          <el-input
                            class="mt10 mb10"
                            v-model="recordToEdit.idNumber"
                          ></el-input>
                        </td>
                      </tr>
                      <tr>
                        <td>出生年月</td>
                        <td>
                          <div class="date mt10">
                            <input
                              type="text"
                              class="min_go_date birthday1 birthday"
                              placeholder="選擇日期"
                              :disabled="id !== 'new' ? true : false"
                            />
                            <span class="el-input__prefix">
                              <i class="el-icon-date"></i>
                            </span>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>職稱</td>
                        <td>
                          <el-input
                            class="mt10 mb10"
                            v-model="recordToEdit.title"
                          ></el-input>
                        </td>
                      </tr>
                      <tr>
                        <td>任期</td>
                        <td>
                          <div class="date mt10">
                            <input
                              type="text"
                              class="min_go_date cadreStartDate1 cadreStartDate"
                              placeholder="選擇日期"
                              :disabled="id !== 'new' ? true : false"
                            />
                            <span class="el-input__prefix">
                              <i class="el-icon-date"></i>
                            </span>
                          </div>
                          ~
                          <div class="date">
                            <input
                              type="text"
                              class="min_go_date cadreEndDate1 cadreEndDate"
                              placeholder="選擇日期"
                              :disabled="id !== 'new' ? true : false"
                            />
                            <span class="el-input__prefix">
                              <i class="el-icon-date"></i>
                            </span>
                          </div>
                        </td>
                      </tr>
                      <tr v-if="false">
                        <td>申請變更項目</td>
                        <td>
                          <el-checkbox-group v-model="recordToEdit.applyType">
                            <el-checkbox
                              v-for="item in applyType"
                              :label="item.label"
                              :key="item.value"
                              >{{ item.label }}</el-checkbox
                            >
                          </el-checkbox-group>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </el-form-item>
                <el-form-item label="受益人分配方式">
                  <el-radio-group v-model="recordToEdit.bnfType" :disabled="isSubmit">
                    <el-radio
                      v-for="(item, index) in bnf"
                      :key="index"
                      :label="item.value"
                      >{{ item.label }}</el-radio
                    >
                  </el-radio-group>
                </el-form-item>
              </el-form>
              <el-button
                type="primary"
                v-if="!isSubmit"
                :disabled="memberInfoError"
                @click="saveMainEdit()"
                >暫存</el-button
              >
              <el-button
                type="primary"
                v-if="!isSubmit && id !== 'new'"
                :disabled="memberInfoError"
                @click="submit"
                >送出</el-button
              >
              <el-button @click="back">取消</el-button>
            </el-tab-pane>
            <el-tab-pane label="受益人資料" v-if="id !== 'new' && listDisplay">
              <workbench
                :api="apiBnf"
                :query="query"
                :columns="columns[recordToEdit.bnfType == 0 ? 0 : 1]"
                :toolbar="toolbar"
                ref="workbench"
                @editData="editData"
                @addData="editData"
                @enumData="getBnfEnumData"
              ></workbench>
              <el-dialog
                title="受益人設定"
                :visible.sync="dialogListForm"
                :modal-append-to-body="false"
                :append-to-body="true"
              >
                <el-form
                  ref="ruleForm"
                  label-position="top"
                  :model="currentEdit"
                  :rules="rules"
                >
                  <el-form-item
                    label="順位"
                    prop="bnfSeq"
                    v-if="recordToEdit.bnfType == 0"
                  >
                    <el-input-number
                      :min="0"
                      v-model="currentEdit.bnfSeq"
                    ></el-input-number>
                  </el-form-item>
                  <el-form-item label="姓名" prop="name">
                    <el-input v-model="currentEdit.name"></el-input>
                  </el-form-item>
                  <el-form-item label="關係" prop="relation">
                    <el-select
                      v-model="currentEdit.relation"
                      placeholder="請選擇關係"
                      class="disblock"
                    >
                      <el-option
                        v-for="(item, index) in bnfDataList"
                        :key="index"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                    <!-- <el-input v-model="currentEdit.relation"></el-input> -->
                  </el-form-item>
                  <el-form-item label="原因" prop="reason">
                    <el-input v-model="currentEdit.reason"></el-input>
                  </el-form-item>
                  <strong style="color: red"
                    >提醒:如是兄弟姊妹或其他，所有欄位必填</strong
                  >
                  <el-form-item label="身分證字號" prop="idNumber">
                    <el-input v-model="currentEdit.idNumber"></el-input>
                  </el-form-item>
                  <el-form-item label="電話" prop="phone">
                    <el-input v-model="currentEdit.phone"></el-input>
                  </el-form-item>
                  <el-form-item label="住址" prop="addr">
                    <el-input v-model="currentEdit.addr"></el-input>
                  </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                  <el-button @click="dialogListForm = false">取消</el-button>
                  <el-button type="primary" @click="submitForm('ruleForm')"
                    >確定</el-button
                  >
                </div>
              </el-dialog>
            </el-tab-pane>
            <el-tab-pane label="申請結果" v-if="id !== 'new'">
              <el-form label-position="top">
                <el-form-item label="申請日期">{{
                  $transferDate(recordToEdit.submitDate)
                }}</el-form-item>
                <el-form-item label="協會送件日期">
                  {{ $transferDate(recordToEdit.genSendDate) }}
                </el-form-item>
                <el-form-item label="協會送件郵局存根條碼">
                  <el-input
                    v-model="recordToEdit.genSendCode"
                    :disabled="true"
                  ></el-input>
                </el-form-item>
                <el-form-item label="核保狀態">{{
                  underwriteStatusAdd[recordToEdit.underwriteStatus]
                }}</el-form-item>
                <!--如果不是加保通過就不顯示-->
                <el-form-item
                  label="保險卡狀態"
                  v-if="recordToEdit.underwriteStatus == 1"
                >
                  <el-radio-group v-model="recordToEdit.insCardSendStatus">
                    <el-radio
                      v-for="(cardSend, index) in cardSendStatus"
                      :key="index"
                      :label="cardSend.value"
                      >{{ cardSend.label }}</el-radio
                    >
                  </el-radio-group>
                </el-form-item>
                <el-form-item
                  v-if="recordToEdit.underwriteStatus === 1"
                  label="保險卡寄送日期"
                  >{{ $transferDate(recordToEdit.insCardSendDate) }}
                </el-form-item>
                <el-form-item
                  v-if="recordToEdit.underwriteStatus === 1"
                  label="生效日期"
                  >{{
                    $transferDate(recordToEdit.insEffectiveDate)
                  }}</el-form-item
                >
                <el-form-item
                  v-if="recordToEdit.underwriteStatus === 1"
                  label="保險公司實收保費"
                  >{{ $addcomma(recordToEdit.realPremium) }}</el-form-item
                >
                <el-form-item
                  v-if="recordToEdit.underwriteStatus === 2"
                  label="退費狀態"
                  >{{ refoundStatus[recordToEdit.refoundStatus] }}</el-form-item
                >
                <el-form-item
                  label="退費金額"
                  v-if="recordToEdit.underwriteStatus === 2"
                  >{{ $addcomma(recordToEdit.backAmount) }}</el-form-item
                >
                <el-form-item label="補件狀態">{{
                  addDocStatus[recordToEdit.needAddDoc]
                }}</el-form-item>
                <el-form-item
                  label="補件通知內容"
                  v-if="recordToEdit.needAddDoc === 1"
                >
                  {{ addDocNotices[0].noticeData }}
                  <br />
                  {{ addDocNotices[0].updateTime }}
                </el-form-item>
              </el-form>
              <el-button type="primary" @click="sendCardSendDate"
                >送出保險卡狀態</el-button
              >
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { API } from "@/assets/config";
import Workbench from "@/components/Workbench";

export default {
  name: "cadre_plusroster_edit",
  components: {
    Workbench,
  },
  data() {
    return {
      id: this.$route.params.subId,
      submitId: this.$route.params.subId,
      code: localStorage.getItem("codeValue"),
      api: "coopInsCadreMemberApply",
      apiBnf: "coopInsCadreMemberApplyBnf",
      recordToEdit: {
        id: "",
        insCadreSubId: "",
        sex: 2,
        applyType: [],
        bnfType: 2,
      },
      toolbar: {},
      isSubmit: false,
      // 取申請人資料失敗（例如年齡不符方案級距）時鎖住暫存／送出
      memberInfoError: false,
      // 初次載入中，避免 recordToEdit 各欄位的 watcher 重複查詢申請人資料
      isInitLoading: false,
      dialogListForm: false,
      currentEdit: {
        applyType: [],
        bnfSeq: "",
        name: "",
        relation: "",
      },
      setTimeKey: [
        "birthday",
        "cadreStartDate",
        "cadreEndDate",
        "genSendDate",
        "subsidyVoucherDate",
      ],
      member: {},
      bnf: {},
      bnfDataList: {},
      data: [],
      yearData: [],
      subData: [],
      selectProject: [],
      underwriteStatusAdd: {},
      refoundStatus: {},
      cardSendStatus: {},
      addDocStatus: {},
      addDocNotices: [{ noticeData: "", updateTime: "" }],
      subFee: 0,
      query: {
        insCadreMemberApplyId:
          this.$route.params.subId == "new" ? 0 : this.$route.params.subId,
        insCadreMainCode: localStorage.getItem("codeValue"),
      },
      columns: [
        [
          {
            label: "順位",
            prop: "bnfSeq",
          },
          {
            label: "身分證字號",
            prop: "idNumber",
          },
          {
            label: "姓名",
            prop: "name",
          },
          {
            label: "關係",
            prop: "relation",
            renderFunction(h, scope, enumData) {
							return h("div", this.$getBnfRelationText(scope.row, enumData.insBnfRelation));
						},
          },
          {
            label: "電話",
            prop: "phone",
          },
          {
            label: "住址",
            prop: "addr",
          },
          {
            prop: "updateTime",
            label: "最後修改",
          },
          {
            prop: "updateUserName",
            label: "最後修改人員",
          },
        ],
        [
          {
            label: "身分證字號",
            prop: "idNumber",
          },
          {
            label: "姓名",
            prop: "name",
          },
          {
            label: "關係",
            prop: "relation",
            renderFunction(h, scope, enumData) {
							return h("div", this.$getBnfRelationText(scope.row, enumData.insBnfRelation));
						},
          },
          {
            label: "電話",
            prop: "phone",
          },
          {
            label: "住址",
            prop: "addr",
          },
          {
            prop: "updateTime",
            label: "最後修改",
          },
          {
            prop: "updateUserName",
            label: "最後修改人員",
          },
        ],
      ],
      titleList: [],
      cadreList: [],
      enumData: {},
      options: [],
      value: "",
      radio: 0,
      account: "",
      show: false,
      listDisplay: false,
      cadreTitle: "",
      SelectCadre: "",
      selectYear: "",
      applyType: [
        {
          label: "姓名",
          value: 0,
        },
        {
          label: "證件號碼 (身分證/居留證等)",
          value: 1,
        },

        {
          label: "出生日期",
          value: 2,
        },
        {
          label: "受益人",
          value: 3,
        },
        {
          label: "其他",
          value: 4,
        },
      ],
      memberData: {},
      rules: {
        bnfSeq: [{ required: true, message: "請輸入順位", trigger: "blur" }],
        name: [{ required: true, message: "請輸入姓名", trigger: "blur" }],
        relation: [
          {
            required: true,
            message: "請選擇受益人關係",
            trigger: "change",
          },
        ],
        idNumber: [
          {
            required: false,
            message: "請輸入身分證字號",
            trigger: "blur",
          },
        ],
        phone: [
          {
            required: false,
            message: "請輸入電話",
            trigger: "blur",
          },
        ],
        addr: [
          {
            required: false,
            message: "請輸入地址",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    this.getData();
  },
  mounted() {
    const vm = this;
    $(".min_go_date").datepicker({
      changeYear: true,
      changeMonth: true,
      currentText: "今天",
      dateFormat: "Rmmdd",
      showButtonPanel: true,
      yearRange: "1912:c+10",
      onSelect(data) {
        let key = $(this)[0].className.split(" ")[2];
        if (data) {
          vm.recordToEdit[key] =
            parseInt(data.split("-")[0]) + 1911 + "-" + data.slice(4);
        }
      },
    });
  },
  filters: {
    sexfilter(item) {
      const sex = ["", "男性", "女性"];
      return sex[item];
    },
  },
  watch: {
    $route() {
      this.getData();
    },
    "recordToEdit.insCadreSubId": {
      handler(key) {
        this.subData.filter((item) => {
          if (item.id == key) {
            this.subFee = item.premium || 0;
          }
        });

        // 年齡級距綁在子方案上，換了方案要重新驗證，否則畫面會停在上一個方案的結果
        if (this.recordToEdit.idNumber && !this.isInitLoading) {
          this.getMemberData();
        }
      },
    },
    "recordToEdit.insCadreYearId": {
      handler(newVal) {
        this.selectProject = this.subData.filter((item) => {
          if (item.insCadreYearId == newVal) {
            return {
              label: item.name,
              value: item.id,
            };
          }
        });
      },
    },
    "currentEdit.relation": {
      handler(newKey) {
        if (newKey == 5 || newKey == 7) {
          this.rules.idNumber[0].required = true;
          this.rules.phone[0].required = true;
          this.rules.addr[0].required = true;

          this.$refs["ruleForm"].clearValidate();
        } else {
          this.rules.idNumber[0].required = false;
          this.rules.phone[0].required = false;
          this.rules.addr[0].required = false;
          this.$refs["ruleForm"].clearValidate();
        }
      },
    },
    "recordToEdit.cadreTitle": {
      handler(newVal) {
        this.SelectCadre = "";
        if (this.selectProject.length <= 0) {
          this.$message({
            type: "warning",
            message: "請先選擇方案",
            duration: 5000,
          });
          this.recordToEdit.cadreTitle = "";
          return;
        }
        if (newVal == 1) {
          // 理事監事
          this.cadreList = this.enumData.coopSupv.map((item) => {
            return {
              label: item.memberName,
              value: item.memberIdNumber,
            };
          });
        } else if (newVal == 2) {
          // 聘任幹部
          this.cadreList = this.enumData.coopLeader.map((item) => {
            return {
              label: item.memberName,
              value: item.memberIdNumber,
            };
          });
        }
      },
    },
    "recordToEdit.bnfType": {
      handler(newVal) {
        if (newVal == 2) {
          this.listDisplay = false;
        } else {
          this.listDisplay = true;
        }
      },
    },
    SelectCadre: {
      handler() {
        // 切換幹部類別時會清空選擇，此時沒有可查詢的對象就別打 API
        if (this.SelectCadre === "") {
          return;
        }
        // 名單選項的 value 就是證件號碼，先填回表單，查詢來源才只有一個
        this.recordToEdit.idNumber = this.SelectCadre;
        this.getMemberData();
      },
      deep: true,
    },
  },
  methods: {
    getBnfEnumData(item) {
      this.bnfDataList = Object.keys(item.insBnfRelation).map((items) => {
        return {
          label: item.insBnfRelation[items],
          value: Number(items),
        };
      });
    },
    //受益人欄位驗證
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.saveDialogEdit();
        } else {
          this.$message.closeAll();
          this.$message({
            type: "error",
            message: `請輸入必填欄位`,
            duration: 5000,
          });
        }
      });
    },
    otherValidate(rules) {
      Object.keys(this.rules).find((item) => {
        if (!this.currentEdit[item]) {
          if (this.rules[item][0].required) {
            this.$message.closeAll();
            this.$message({
              type: "error",
              message: `${this.rules[item][0].message}`,
              duration: 5000,
            });
            return;
          }
        }
      });
    },
    getData() {
      let url =
        API[this.api] +
        `?id=${this.id === "new" ? 0 : this.id}&insCadreMainCode=${
          this.code
        }&type=plus`;

      const thenCB = (json) => {
        let newObj = {
          ...json.resultData.data,
          subsidyAmount: this.$addcomma(json.resultData.data.subsidyAmount),
        };
        this.isInitLoading = true;
        this.recordToEdit = Object.assign({}, this.recordToEdit, newObj);
        // 選擇幹部名單 取 hireTitle 的前兩個
        let title = json.resultData.enumData.cadreType;
        this.titleList = Object.keys(title)
          .map((key) => {
            return {
              label: title[key],
              value: parseInt(key),
            };
          })
          .slice(0, 2);
        this.enumData = json.resultData.enumData;
       
        this.yearData = json.resultData.enumData.insCadreYear.map((item) => {
          return { label: item.year-1911, value: item.id };
        });
        this.subData = json.resultData.enumData.insCadreSub.map((item) => {
          return { label: item.name, value: item.id, ...item };
        });
        // 補件通知內容
        this.addDocNotices = json.resultData.addDocNotices;

        if (this.recordToEdit.isSubmit == 0) {
          this.isSubmit = false;
        } else if (this.recordToEdit.isSubmit == 1) {
          this.isSubmit = true;
        }
        this.recordToEdit.insCadreMainCode = localStorage.getItem("codeValue");
        this.renderAgent(json.resultData.enumData);

        this.isSubmit = this.recordToEdit.isSubmit == 1;

        if (this.recordToEdit.bnfType == 2) {
          this.listDisplay = false;
        } else {
          this.listDisplay = true;
        }

        if (this.id !== "new") {
          this.query.insCadreMemberApplyId = this.$route.params.subId;
        }
        this.underwriteStatusAdd =
          json.resultData.enumData.insCadreUnderwriteStatusAdd;
        this.cardSendStatus = this.renderEnum(
          json.resultData.enumData.insCadreApplyCardSendStatus
        );
        this.refoundStatus =
          json.resultData.enumData.insCadreApplyRefoundStatus;
        this.addDocStatus = json.resultData.enumData.insCadreApplyAddDocStatus;
        setTimeout(() => {
          this.setTimeKey.forEach((item) => {
            $(`.${item}`).val(
              `${
                parseInt(json.resultData.data[item]) - 1911 < 100
                  ? `0${parseInt(json.resultData.data[item]) - 1911}${
                      json.resultData.data[item].slice(4).split(" ")[0]
                    }`
                  : `${parseInt(json.resultData.data[item]) - 1911}${
                      json.resultData.data[item].slice(4).split(" ")[0]
                    }` || ""
              }`
            );
          });
        }, 1);
        // watcher 會在本次 tick 結束時統一觸發，等它們跑完才解除載入旗標
        this.$nextTick(() => {
          this.isInitLoading = false;
        });
      };
      this.mAxiosGet(url, thenCB);
    },
    renderAgent(enumData) {
      // 受益人分配方式額外處理
      let arr = [];
      Object.keys(enumData.bnfType).map((key) => {
        arr.push({
          label: enumData.bnfType[key],
          value: parseInt(key),
        });
      });
      this.bnf = arr.reverse();
    },
    /**
     * 向後端取得申請人資料，順便由後端驗證年齡是否符合方案級距。
     * 這是唯一發出 getMemberInfo 的地方，成功與失敗都在這裡更新 memberInfoError，
     * 避免有入口漏設旗標讓不合規的資料還能暫存／送出。
     * 一律以表單上的證件號碼為查詢對象，從名單挑人時由 watcher 先填回表單。
     * @returns {Promise<void>}
     */
    async getMemberData() {
      const url = API.coopInsCadreMemberApply;
      const params = {
        action: "getMemberInfo",
        insCadreMainCode: this.code,
        insCadreSubId: this.recordToEdit.insCadreSubId,
        idNumber: this.recordToEdit.idNumber,
      };

      let data;
      try {
        const json = await this.mAxiosGet(url, params);
        data = json.resultData.data;
        this.memberInfoError = false;
      } catch (error) {
        // 錯誤訊息由 mixin 統一顯示；這裡鎖住暫存／送出，
        // 避免年齡不符方案級距等狀況還被存進資料庫
        this.memberInfoError = true;
        return;
      }

      // 查無有效社員（含清空名單選擇時帶的 empty），保留表單原本的內容
      if (!data.name) {
        return;
      }

      this.recordToEdit = Object.assign({}, this.recordToEdit, data);
      // 後端回的是西元日期，要轉成民國格式才塞得回 datepicker
      setTimeout(() => {
        this.setTimeKey.forEach((item) => {
          // setTimeKey 涵蓋整頁的日期欄位，這支 API 不會回傳全部
          if (!data[item]) {
            return;
          }
          $(`.${item}`).val("");
          $(`.${item}`).val(
            `${
              parseInt(data[item]) - 1911 < 100
                ? `0${parseInt(data[item]) - 1911}${
                    data[item].slice(4).split(" ")[0]
                  }`
                : `${parseInt(data[item]) - 1911}${
                    data[item].slice(4).split(" ")[0]
                  }` || ""
            }`
          );
        });
      }, 1);
    },
    editData(id, row) {
      // edit
      this.currentEdit = {
        bnfSeq: "",
        name: "",
        relation: "",
        phone: "",
        idNumber: "",
        addr: "",
        reason: "",
      };
      this.dialogListForm = true;
      if (id !== "new") {
        this.currentEdit = Object.assign({}, row);
      }
      this.$nextTick(() => {
        this.$refs["ruleForm"].clearValidate();
      });
    },
    submit() {
      this.$confirm(
        "是否確認資料已填寫完畢(包含受益人，如已選擇法定繼承人則免填)",
        "提示訊息",
        {
          confirmButtonText: "是",
          cancelButtonText: "否",
          type: "warning",
        })
        .then(
          async () => {
            // 先 await 暫存，避免 update 與 submit 並行造成 race
            try {
              const saved = await this.saveMainEdit({ silent: true });
              if (!saved) {
                // 暫存沒通過就不要往下送出
                return;
              }
         
              let url = API.coopInsCadreMemberApply + `?action=submit`;
              let form = new FormData();
              form.append("id", this.submitId);
              await this.mAxiosPost(url, form);
            
              this.showAjaxSuccessMsg();
              this.getData();
            } catch (error) {
              console.error(error);
            }
          },
          () => {
            // 只接 $confirm 的取消，送出流程自己的錯誤不該被誤報成使用者取消
            this.$message({
              type: "warning",
              message: "已取消送出",
              duration: 5000,
            });
          }
        );
    },
    async saveMainEdit(options = {}) {
      const silent = options.silent === true;
      if (!this.checkSub()) {
        return null;
      }

      let url = API.coopInsCadreMemberApply;
      let form = this.buildMainFormData();
      if (this.id !== "new" && this.id !== 0 && this.id) {
        form.append("id", this.id);
        url += `?action=update`;
      } else {
        url += `?action=append`;
      }

      const json = await this.mAxiosPost(url, form);
      this.submitId = json.resultData.id;
      this.id = json.resultData.id;
      if (!silent) {
        this.showAjaxSuccessMsg();
        this.$router.push({
          name: "cadrecoop_plusroster_edit",
          params: { subId: json.resultData.id },
        });
      }
      return json;
    },
    buildMainFormData() {
      let form = new FormData();

      form.append("bnfType", this.recordToEdit.bnfType || 0);
      form.append("name", this.recordToEdit.name || "");
      form.append("sex", this.recordToEdit.sex || "");
      form.append("insCadreMainCode", this.code || "");
      form.append("idNumber", this.recordToEdit.idNumber || "");
      // 統一預設值，避免後端數值/日期轉型報錯
      form.append("birthday", this.recordToEdit.birthday || "");
      form.append("title", this.recordToEdit.title || "");
      form.append("cadreType", this.recordToEdit.cadreTitle || "");
      form.append("insCadreSubId", this.recordToEdit.insCadreSubId || "");
      form.append("insCadreYearId", this.recordToEdit.insCadreYearId || "");
      form.append("memberId", this.recordToEdit.memberId ? this.recordToEdit.memberId : 0);
      form.append("cadreStartDate", this.recordToEdit.cadreStartDate || "");
      form.append("cadreEndDate", this.recordToEdit.cadreEndDate || "");
      form.append("isMember", this.SelectCadre == "" ? 0 : 1);
      if (this.recordToEdit.applyType) {
        form.append("applyType", this.recordToEdit.applyType || "");
      }

      return form;
    },
    /**
     * 檢查是否已選擇子方案，未選時顯示提示
     * @returns {boolean} 是否通過檢查
     */
    checkSub() {
      if (this.recordToEdit.insCadreSubId) {
        return true;
      }
      this.$message.closeAll();
      this.$message.error("請先選擇子方案");
      return false;
    },
    saveDialogEdit() {
      let url = API[this.apiBnf];
      let form = new FormData();
      if (
        this.currentEdit.id !== "new" &&
        this.currentEdit.id !== 0 &&
        this.currentEdit.id
      ) {
        form.append("id", this.currentEdit.id);
        url += `?action=update`;
      } else {
        url += `?action=append`;
      }

      form.append("bnfSeq", this.currentEdit.bnfSeq || 0);
      form.append("idNumber", this.currentEdit.idNumber || "");
      form.append("name", this.currentEdit.name || "");
      form.append("relation", this.currentEdit.relation || "");
      form.append("phone", this.currentEdit.phone || "");
      form.append("addr", this.currentEdit.addr || "");
      form.append("insCadreMemberApplyId", this.id);

      let thenCB = (json) => {
        this.showAjaxSuccessMsg();
        this.$refs.workbench.getData();
      };
      this.mAxiosPost(url, form, thenCB);
      this.dialogListForm = false;
    },
    getCadre(key) {
      let title = "";
      this.titleList.filter((item) => {
        if (item.value == key) {
          title = item.label;
        }
      });
      return title;
    },
    resetAmount(amount) {
      return (this.recordToEdit.subsidyAmount = this.$addcomma(
        this.$removeComma(amount)
      ));
    },
    sendCardSendDate() {
      const url = API.coopInsCadreMemberApply + "?action=sendCardSendDate";
      const form = new FormData();
      form.append("insCadreMemberApplyId", this.id);
      form.append("insCardSendStatus", this.recordToEdit.insCardSendStatus);
      const thenCB = (json) => {
        this.showAjaxSuccessMsg();
      };
      this.mAxiosPost(url, form, thenCB);
    },
    back() {
      this.$router.push({
        name: "cadrecoop_plusroster",
      });
    },
    renderEnum(enumData) {
      return Object.keys(enumData).map((key) => {
        return { label: enumData[key], value: parseInt(key) };
      });
    },
  },
};
</script>
<style lang="scss" scoped>
table.info td {
  padding-top: 0;
  padding-bottom: 0;
}
.el-message-box {
  .el-message-box__content {
    font-size: 18px;
  }
}
.disblock {
  display: block;
}
</style>